export default __webpack_public_path__ + "552c37706c0289bf865a372f7220a8d1.png";